import React, {FC} from 'react';
import CloseIcon from '@mui/icons-material/Close';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import {Button} from '@mui/material';

import "./HideContentButton.scss";
import {hasItemContent, isEmailContent} from '../../domain/ItemContent';
import {ContentLocation} from "../../locations/ContentLocation";
import {useAppDispatch, useAppSelector, useAppStore} from "../../hooks/ReduxHooks";
import {isTearOffWindow} from "../../App";
import {getItemContent} from "../../state/ItemState";
import {EmailActions} from "../../actions/EmailActions";
import {markSelectedEmailAsRead} from "../../locations/EmailLocation";

export function popOutContent() {
    window.open(window.location.href, "_blank", "popup=true");
}

export const HideContentButton: FC = () => {
    const hasContent = useAppSelector(s => hasItemContent(getItemContent(s.itemState)));// || s.usersState.selectedUser);

    const dispatch = useAppDispatch();
    const store = useAppStore();

    if (!hasContent) {
        return null;
    }

    function onClearItemContent() {
        const itemContent = getItemContent(store.getState().itemState);
        if (isEmailContent(itemContent)) {
            // This handles the case for mobile/content view only
            markSelectedEmailAsRead(dispatch, itemContent.Emails.filter(e => e.Id === itemContent.Id));
        }
        dispatch(EmailActions.clearItemContent());
        ContentLocation.clearItemContent();
    }

    return (
        <>
            <Button onClick={onClearItemContent} size="small" className="hide-content-button" title="Close">
                <CloseIcon/>
            </Button>
            {!isTearOffWindow && <Button onClick={popOutContent} size="small" className="expand-content-button" title="Pop-out">
                <AspectRatioIcon/>
            </Button>}
        </>
    );
};
